<template>
  <div>
    <Section>
      <template v-slot:section-header>
        <h5 class="title">แกลเลอรี</h5>
        <div class="action">
          <div class="btn-container">
            <button
              v-if="!disabledEdit"
              type="button"
              class="btn btn-light"
              @click.stop="onSelectGalleryButtonClicked">
              {{!isGalleryEmpty ? 'เปลี่ยนแกลเลอรี' : 'เลือกแกลเลอรี'}}
            </button>
          </div>
        </div>
      </template>
      <template v-slot:section-body>
        <GalleryListModal
          v-if="galleryActiveModal === 'ShowGalleriesListModal'" />
        <GalleryNewModal
          v-if="galleryActiveModal === 'NewGalleryModal'" />
        <GalleryEditModal
          class="modal-images-manager"
          v-if="galleryActiveModal === 'EditGalleryModal'" />
        <List v-if="!isGalleryEmpty && !isGalleryLoadingError">
          <template v-slot:list-body>
            <div class="list-item-container no-underline">
              <div class="list-item-image">
                <ImageView
                  :source="currentGallery.coverImage ? currentGallery.coverImage : ''"
                  imageSize="cover160w90h" />
              </div>
              <div class="list-item-detail">
                <div class="list-item list-item-primary list-item-title">
                  {{ currentGallery.title ? currentGallery.title : 'Untitled Album' }}
                </div>
                <div class="list-item list-item-secondary">
                  {{ `${currentGallery.itemCount ? `จำนวนภาพ: ${currentGallery.itemCount}` : 'ไม่มีภาพในแกลเลอรี'}` }}
                </div>
                <div class="list-item list-item-action">
                  <div class="action-container">
                    <DoubleTabToConfirmButton
                      v-if="!disabledEdit"
                      text='คลิกอีกครั้งเพื่อนำออก'
                      @confirm="onConfirmRemoveClicked"/>
                    <button
                      v-if="!disabledEdit"
                      type="button"
                      class="btn btn-light btn-action"
                      @click.stop="onEditButtonClicked()">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </List>
        <!-- gallery error -->
        <EmptyMessage
          v-if="isError404"
          class="empty-small">
          <h5 class="title"><i class="fas fa-exclamation-triangle"></i> แกลเลอรีที่เลือกไว้ ได้ถูกลบไปแล้ว</h5>
          <button
            v-if="!disabledEdit"
            type="button"
            class="btn btn-light mt-2"
            @click="onSelectGalleryButtonClicked">
            เลือกแกลเลอรีใหม่
          </button>
        </EmptyMessage>
        <!-- empty gallery -->
        <EmptyMessage
          v-if="!isGalleryLoadingError && isGalleryEmpty"
          class="empty-small">
          <h5 class="title">ไม่มีแกลเลอรี</h5>
          <button
            v-if="!disabledEdit"
            type="button"
            class="btn btn-light mt-2"
            @click="onSelectGalleryButtonClicked">
            {{ emptyText }}
          </button>
        </EmptyMessage>
      </template>
    </Section>
  </div>
</template>

<script>
// Systems
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import DoubleTabToConfirmButton from '@/components/DoubleTapToConfirmButton.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import ImageView from '@/image/ImageView.vue';
import List from '@/components/List.vue';
import Section from '@/components/Section.vue';

// Modals
import GalleryListModal from './modals/GalleryListModal.vue';
import GalleryEditModal from './modals/GalleryEditModal.vue';
import GalleryNewModal from './modals/GalleryNewModal.vue';

export default {
  props: {
    source: {
      type: String,
      default: () => {},
    },
    disabledEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emptyText: 'เลือกแกลเลอรีสำหรับวิดีโอนี้',
    };
  },
  computed: {
    ...mapGetters([
      'currentGallery',
      'selectedGallery',
      'galleryActiveModal',
      'loadCurrentGalleryState',
    ]),
    isGalleryEmpty() {
      return _.isEmpty(this.currentGallery);
    },
    isGalleryLoadingError() {
      return this.loadCurrentGalleryState.error.statusCode;
    },
    isError404() {
      return this.loadCurrentGalleryState.error.statusCode === 404;
    },
  },
  components: {
    Section,
    EmptyMessage,
    GalleryListModal,
    GalleryEditModal,
    GalleryNewModal,
    List,
    ImageView,
    DoubleTabToConfirmButton,
  },
  created() {
    if (this.source !== 'video') {
      this.emptyText = 'เลือกแกลเลอรีสำหรับรายการนี้';
    }
  },
  methods: {
    ...mapActions([
      'setGalleryActiveModal',
      'setSelectedGallery',
      'destroyCurrentGalleryState',
    ]),
    onConfirmRemoveClicked() {
      this.destroyCurrentGalleryState();
    },
    onEditButtonClicked() {
      if (_.isEmpty(this.selectedGallery)) {
        this.setSelectedGallery(this.currentGallery);
      }
      this.setGalleryActiveModal('EditGalleryModal');
    },
    onSelectGalleryButtonClicked() {
      this.setGalleryActiveModal('ShowGalleriesListModal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.section .section-header .title {
  font-weight: normal;
  font-size: 1.09375rem;
}

</style>
